/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useRef, useState } from 'react'
import FormCreator from '../../../../../components/Forms/FormCreator'
import changePasswordInfo from '../ChangePassword.data'
import Buttons from '../../../../../components/ui/button/Buttons'
import { useResetPasswordMutation } from '../../../../../app/services/userAPI'
import ToastService from '../../../../../services/toastService/ToastService'
import { securityKey } from '../../../../../data/SecurityKey'
import { hasFunctionalPermission } from '../../../../../utils/AuthorizeNavigation/authorizeNavigation'

const ChangePassword = (props) => {

    const [passwordForm, setPasswordForm] = useState(changePasswordInfo);
    const [isButtonDisable, setIsButtonDisable] = useState(false);


    const [resetPassword, { isLoading, isSuccess, data: resetPasswordData }] = useResetPasswordMutation();
    const passwordFormRef = useRef()

    const hasEditPermission = hasFunctionalPermission(securityKey.EDITUSER);

    const userId = props.userId;

    const { formSetting } = changePasswordInfo

    // Function to reset form (setting initial values)
    const resetForm = () => {
        const formData = { ...changePasswordInfo }
        formData.initialState = { ...changePasswordInfo.initialState }
        setPasswordForm(formData)
    }

    // Function to handle update password click
    const handlePassword = () => {
        const formData = passwordFormRef.current.getFormData();
        if (userId && formData) {
            const reqParams = {
                userId,
                password: formData.password,
                passwordResetRequired: false
            }
            resetPassword(reqParams);
        }
    }

    // Effect to handle EDIT Security Permission
    useEffect(() => {
        if (userId) {
            if (hasEditPermission.isViewOnly === true) {
                formSetting.isViewOnly = true;
                setIsButtonDisable(true);
            }
            else {
                formSetting.isViewOnly = false;
                setIsButtonDisable(false);
            }
        }
    }, [userId, hasEditPermission, formSetting.isViewOnly])

    // Effect to handle a successful updation of password
    useEffect(() => {
        if (isSuccess && resetPasswordData) {
            ToastService.success(resetPasswordData.errorMessage);
            resetForm();
        }
    }, [isSuccess, resetPasswordData])

    return (
        <>
            <form>
                <div className='row'>
                    <FormCreator ref={passwordFormRef} {...passwordForm} />
                </div>
            </form>
            <div className='row mt-2'>
                <div className='col-12'>
                    <div className="form-btn d-flex justify-content-end">
                        <Buttons
                            buttonTypeClassName="success-btn ml-5"
                            onClick={handlePassword}
                            buttonText="Update Password"
                            isLoading={isLoading}
                            isDisable={isButtonDisable}
                        />
                    </div>
                </div>
            </div>
        </>
    )
}

export default ChangePassword;